//packages
import React, { Component } from 'react'

//form elements
import PopoverOfForm from '../../PopoverOfForm'

class CaseTitleTooltip extends Component {
    render () {
        return (
            <PopoverOfForm>
                <p>To search for a specific case title, enter the title in this field.</p>
                <p>Cast Title searches are not case sensitive, so it doesn't matter if you enter any combination of lower or upper case letters.</p>
                    <p>A search wildcard is assumed at the end of the search string. Use the '*' character to specify a wildcard in your search.</p>
                    <p>Enter all available search criteria into the form for fastest results. Multiple fileds can be used in the search.</p>
            </PopoverOfForm>
        )
    }
}

export default CaseTitleTooltip



// WEBPACK FOOTER //
// ./src/components/search/FormElements/tooltips/caseTitleTooltip/CaseTitleTooltip.js